<template>
  <nav dir="ltr" class="pagination is-small is-centered">
    <a
      class="pagination-previous"
      @click="prevPage"
      :disabled="currentPage === 1"
    >
      <div class="is-size-6 has-text-black has-text-weight-bold">&nbsp;&lt;&nbsp;</div>
    </a>

    <ul class="pagination-list is-flex-grow-0">
      <li v-for="page in pagesToShow" :key="page">
        <span v-if="page === '...'" class="pagination-ellipsis">&hellip;</span>
        <a
          v-else
          class="has-text-black pagination-link"
          :class="{ 'is-current': page === currentPage }"
          @click="changePage(page)"
        >
          {{ page }}
        </a>
      </li>
    </ul>

    <a
      class="pagination-next"
      @click="nextPage"
      :disabled="currentPage === totalPages"
    >
      <div class="is-size-6 has-text-black has-text-weight-bold">&nbsp;>&nbsp;</div>
    </a>

    <div class="select mr-3">
      <select v-model="perPage" @change="$emit('per-page-change', perPage)" style="min-width: 70px;">
        <option v-for="option in [1, 10, 20, 50]" :key="option" :value="option">
          {{ option }}
        </option>
      </select>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      perPage: 10
    }
  },
  computed: {
    pagesToShow () {
      const maxPagesToShow = 7
      const pages = []

      if (this.totalPages <= maxPagesToShow) {
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i)
        }
      } else {
        if (this.currentPage <= 4) {
          pages.push(1, 2, 3, 4, 5, '...', this.totalPages)
        } else if (this.currentPage >= this.totalPages - 3) {
          pages.push(1, '...', this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages)
        } else {
          pages.push(1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages)
        }
      }

      return pages
    }
  },
  methods: {
    changePage (page) {
      if (page !== '...' && page !== this.currentPage) {
        this.$emit('page-change', page)
      }
    },
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.$emit('page-change', this.currentPage + 1)
      }
    },
    prevPage () {
      if (this.currentPage > 1) {
        this.$emit('page-change', this.currentPage - 1)
      }
    }
  }
}
</script>
